import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  openSearch: false,
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    toogleSearch: (state) => {
      state.openSearch = !state.openSearch;
    },
  },
});
export const { toogleSearch } = searchSlice.actions;
export default searchSlice.reducer;
